module.exports = __webpack_public_path__ + "assets/img/chatbotTest.b156317a.png";